import { Formik } from 'formik';
import { isEmpty } from 'lodash';
import React from 'react';
import Form, { FormElement } from '@dashboard/components/Form';
import FormSubmit from '@dashboard/components/Formik/components/FormSubmit';
import { TextInput } from '@dashboard/components/Formik';
import FormError from '@dashboard/components/Formik/components/FormError';
import { transformApiErrorToFormik } from '@dashboard/services/form';
import usePage from '@dashboard/hooks/usePage';

const SlugForm = () => {
  const { page, updatePage } = usePage();

  return (
    <Formik
      initialValues={{
        slug: page.slug,
      }}
      onSubmit={async (values, actions) => {
        actions.setStatus(undefined);

        const { data, error } = await updatePage.mutateAsync(values);

        if (data) {
          actions.setStatus('');
          actions.resetForm({
            values: {
              slug: data.slug,
            },
          });
        } else {
          const { status, errors } = transformApiErrorToFormik(error);

          if (!isEmpty(errors)) {
            actions.setErrors(errors);
          } else {
            actions.setStatus(status);
          }
        }
      }}
    >
      {({ status, dirty, handleSubmit }) => (
        <Form onSubmit={handleSubmit}>
          <FormElement>
            <TextInput name="slug" id="slug" type="text" placeholder="URL slug" required border />
            <FormError name="slug" />
          </FormElement>

          <FormElement>{status && status}</FormElement>

          <FormSubmit>
            <FormSubmit.Button>Save</FormSubmit.Button>
            <FormSubmit.State visible={!!dirty} />
          </FormSubmit>
        </Form>
      )}
    </Formik>
  );
};

export default SlugForm;
